import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getData } from "../../Services/getData";
import { endpoints } from "../../Utils/UrlEnum";
import { ModuleModel } from "../../Utils/Models";
import { Grid, Paper } from "@mui/material";
import ModuleCard from "./ModuleCard";
import genericStyles from "../../Styles/genericStyles.module.css";

export default function CoursesPage() {
  const { courseId } = useParams();
  const [modules, setModules] = useState<ModuleModel[]>();

  useEffect(() => {
    getData(`${endpoints.modules}/byCourse/${courseId}`).then((response) => {
      if (response.data) setModules(response.data);
    });
  }, [courseId]);

  return (
    <div className={genericStyles.mainContainer}>
      <Paper elevation={0} className={genericStyles.scrollableContainer}>
        <Grid container spacing={8}>
          {modules?.map((module) => (
            <Grid item xs={12} sm={6} md={3} key={module._id}>
              <ModuleCard module={module} />
            </Grid>
          ))}
        </Grid>
      </Paper>
    </div>
  );
}
